import React, { useState } from "react";
import { useT } from "../helpers/useT";
import { constructAthenaUrl, ListResponse, useFetch } from "../api/useFetch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../components/List/Table";
import { Headline } from "../components/Headline";
import { EmptyListPlaceholder } from "../components/List/EmptyList";
import { ListFilters, Pagination } from "../components/List/List";
import { Status } from "../components/Status";
import DetailsLink from "../components/DetailsLink";
import Loading, { ErrorPage } from "../components/Loading";
import { HadesChauffeur } from "./chauffeur";
import { AddRecordLink } from "../list/AddItemToListCTA";
// @ts-ignore
import { chauffeurAdd } from "../routes";
// @ts-ignore
import { CanDos } from "types/Role";
import { trackError } from "../tracking/error";

export function ChauffeurList({ canDo }: { canDo: CanDos }) {
  const t = useT();
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading, error } = useFetch<ListResponse<HadesChauffeur>>(
    constructAthenaUrl("/hades/drivers", {
      "page[number]": `${currentPage}`,
      "page[size]": "30",
      "filter[state]": "live,on_hold",
    }),
  );

  if (error) {
    trackError("Error loading chauffeur list", error);
    return <ErrorPage />;
  }

  if (isLoading || !data) {
    return <Loading />;
  }

  return (
    <>
      <Headline title={t("chauffeurs.title")} flex={true}>
        {canDo.add && (
          <AddRecordLink link={chauffeurAdd()}>
            {t("chauffeurs.add-item-link")}
          </AddRecordLink>
        )}
      </Headline>
      <ListFilters
        recordCount={t("chauffeurs.record-count", {
          number: data.meta.record_count,
        })}
      />
      <EmptyListPlaceholder data={data.data} title={t("chauffeurs.empty-list")}>
        <Table>
          <TableHead>
            <TableHeaderRow>
              <TableHeaderCell>{t("shared.name")}</TableHeaderCell>
              <TableHeaderCell width={170}>
                {t("shared.mobile")}
              </TableHeaderCell>
              <TableHeaderCell>{t("shared.email")}</TableHeaderCell>
              <TableHeaderCell width={90}>{t("shared.state")}</TableHeaderCell>
              <TableHeaderCell width={60} />
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.data.map((chf) => (
              <TableRow key={chf.id}>
                <TableCell>
                  {chf.attributes.first_name} {chf.attributes.last_name}
                </TableCell>
                <TableCell>{chf.attributes.mobile}</TableCell>
                <TableCell>{chf.attributes.email}</TableCell>
                <TableCell>
                  <Status status={chf.attributes.state} />
                </TableCell>
                <TableCell>
                  <DetailsLink section="chauffeurs" qs={{ id: chf.id }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Pagination
          currentPage={currentPage}
          pageCount={data.meta.page_count}
          onPageClick={setCurrentPage}
        />
      </EmptyListPlaceholder>
    </>
  );
}
